// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const Title = styled.div`
  text-transform: uppercase;
  color: ${theme.BasketCombinationsSummary.titleColor};
`;

const BetsCounter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const BetsCounterLabel = styled.div`
  font-size: 0.9em;
  color: ${theme.BasketCombinationsSummary.counterLabelColor};
`;

const BetsCounterNumber = styled.div`
  font-size: 1.1em;
  color: ${theme.BasketCombinationsSummary.counterNumberColor};
`;

type BasketCombinationsHeaderProps = {
  label: string;
  counter?: number;
  className?: string;
};

const BasketCombinationsHeader = ({ label, counter, className }: BasketCombinationsHeaderProps) => {
  return (
    <Header className={className}>
      <Title>{label}</Title>
      {counter ? (
        <BetsCounter>
          <BetsCounterLabel>{__('Number of bets')}</BetsCounterLabel>&nbsp;
          <BetsCounterNumber>{counter}</BetsCounterNumber>
        </BetsCounter>
      ) : null}
    </Header>
  );
};

export default BasketCombinationsHeader;
